import { makeSimpleMapper } from "@/core/acl/mapperFactory";
import { zEmployeeSchemaDom, zEmployeeSchemaCreateDom, } from "@/types/employe/employee.domain";
import { zEmployeeSchemaDto, zEmployeeSchemaCreateDto, } from "@/types/employe/employee.dto";
export const EmployeeMapper = makeSimpleMapper({
    dtoToDomain: (dto) => zEmployeeSchemaDom.parse(dto),
    domainToDto: (domain) => zEmployeeSchemaDto.parse(domain),
    dtoToCreateDto: (domain) => zEmployeeSchemaCreateDto.parse(domain),
    dtoToCreateDom: (dto) => zEmployeeSchemaCreateDom.parse(dto),
});
